import { render, staticRenderFns } from "./LawAuthorityTypeForm.vue?vue&type=template&id=f2fc4438&"
import script from "./LawAuthorityTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityTypeForm.vue?vue&type=style&index=0&id=f2fc4438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports